<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <div>
      <mat-form-field class="numerical" floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.length') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') + ':' + (inspection?.title || '') + ':length'
          "
          [drawableFieldTitle]="t('inspection.fields.length')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.length"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <mat-form-field class="numerical" floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.width') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') + ':' + (inspection?.title || '') + ':width'
          "
          [drawableFieldTitle]="t('inspection.fields.width')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.width"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <mat-form-field class="numerical" floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.depth') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') + ':' + (inspection?.title || '') + ':depth'
          "
          [drawableFieldTitle]="t('inspection.fields.depth')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.depth"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <mat-form-field class="numerical" floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.volume') }}</mat-label>
        <input
          type="number"
          matInput
          placeholder="0"
          [ngModel]="inspection.volume"
          [readonly]="true"
        />
      </mat-form-field>
    </div>
  </authority-labs-check-case>
</ng-container>
